var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[
    `cv-header-panel`,
    `${_vm.carbonPrefix}--header-panel`,
    { [`${_vm.carbonPrefix}--header-panel--expanded`]: _vm.panelExpanded },
  ],attrs:{"aria-hidden":!_vm.panelExpanded ? 'true' : 'false',"id":_vm.id},on:{"focusout":_vm.onFocusout,"mousedown":_vm.onMouseDown}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }